// Walk every page of a limit/offset endpoint and concatenate the items, so callers
// that need the whole collection aren't capped by the server's per-request limit.
//
// `fetchPage(limit, offset)` must resolve to `{ items, count }`, where `count` is the
// total number of matching rows. Paging stops when a page comes back empty (the
// safety net if `count` is wrong) or once we've collected `count` items.
export async function fetchAllPages (fetchPage, { pageSize = 200 } = {}) {
  let offset = 0
  let items = []
  let count = 0
  for (;;) {
    const page = await fetchPage(pageSize, offset)
    const pageItems = page.items || []
    items = items.concat(pageItems)
    count = page.count || 0
    offset += pageSize
    if (pageItems.length === 0 || items.length >= count) {
      break
    }
  }
  return { items, count }
}

export default fetchAllPages
